export default "__VITE_ASSET__B1d11u5T__"